import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import RequireAuth from "./components/services/RequireAuth";
import RequireOTP from "./components/services/RequireOTP";
import ResumeProvider from "./components/services/ResumeProvider";
import ResumeBanner from "./components/ResumeBanner";
import TokenExpirationModal from "./components/services/TokenExpirationModal";
// Groupes de routes par domaine
import ProductionRoutes from "./routes/ProductionRoutes";
import SinistreRoutes from "./routes/SinistreRoutes";
import ParametresRoutes from "./routes/ParametresRoutes";
import OtherRoutes from "./routes/OtherRoutes";
// Pages d'authentification
import AfterRegistrationPage from "./pages/auth/AfterRegistrationPage";
import ConfirmOTP from "./pages/auth/ConfirmOTP";
import FirstConnexion from "./pages/auth/FirstConnexion";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import RegisterEtablissement from "./pages/auth/RegisterEtablissement";
import ResetPassword from "./pages/auth/ResetPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";
// Pages publiques
import CheckAuthenticity from "./pages/certificate-download-platform/CheckAuthenticity";
import DownloadCertificates from "./pages/certificate-download-platform/DownloadCertificates";
import MobileAppDownloadPage from "./pages/mobile-app/MobileAppDownloadPage";
import MobileAppReleasesAdmin from "./pages/mobile-app/MobileAppReleasesAdmin";
import InsuranceVerification from "./pages/verifications/InsuranceVerification";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
    return (
        <div>
            <BrowserRouter>
                <ResumeProvider>
                    <ToastContainer position="top-center" />
                    <ResumeBanner />
                    <TokenExpirationModal />
                    <Routes>
                        {/* Routes publiques */}
                        <Route path="/download" element={<MobileAppDownloadPage />} />
                        <Route path="/admin/releases" element={<MobileAppReleasesAdmin />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/verifier-email" element={<VerifyEmail />} />
                        <Route path="/nouveau-mot-de-passe" element={<ResetPassword />} />
                        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                        <Route path="/first-connexion" element={<FirstConnexion />} />
                        <Route path="/connexion" element={<Login />} />
                        <Route path="/waiting" element={<AfterRegistrationPage />} />
                        <Route path="/inscription" element={<Register />} />
                        <Route path="/inscription-etablissement" element={<RegisterEtablissement />} />
                        <Route path="/attestation-digitale" element={<DownloadCertificates />} />
                        <Route path="/verification" element={<InsuranceVerification />} />
                        <Route path="/authentifier-mon-attestation" element={<CheckAuthenticity />} />
                        <Route element={<RequireAuth />}>
                            <Route path="/confirm-otp" element={<ConfirmOTP />} />
                        </Route>
                        <Route path="/assets/**" element={<Navigate to="/" />} />

                        {/* Routes protégées — groupées par domaine */}
                        <Route element={<RequireOTP />}>
                            {ProductionRoutes()}
                            {SinistreRoutes()}
                            {ParametresRoutes()}
                            {OtherRoutes()}
                        </Route>

                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </ResumeProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
